import axios from '../library/axios';
import { getSlug, setHrefWithSlugHook } from '../config/routes/guards/slug';
import { MySwal } from '../library/swal';

const hospitalTokenKey = () => `token${getSlug() ? `-${getSlug()}` : ''}`;

export const runHospitalVerificationSetup = async (record, options = {}) => {
  const { showSuccessModal = true, redirectDelayMs = 3000, redirect = true } = options;

  await axios({
    url: '/users/stepFirst',
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem(hospitalTokenKey()) || ''}`,
    },
  });

  const profileRes = await axios({
    url: '/profile/create',
    method: 'POST',
    data: {
      namaRs: record.Nama,
      kodeRs: record.KodeRs,
      direktur: record.Direktur,
      alamat: record.Alamat,
      telp: record.Telp,
      website: record.Website,
      email: record.emailRs,
    },
  });

  await axios({
    url: '/contact-person/create-contact-person',
    method: 'POST',
    data: {
      idProfile: profileRes.data.id,
      namaDepan: record.NamaDepan,
      namaBelakang: record.NamaBelakang,
      namaPanggilan: record.NamaPanggilan,
      email: record.EmailPic,
      hp1: record.Hp1,
      hp2: record.Hp2,
      gender: record.Gender === 'P' ? 'Pria' : 'Wanita',
    },
  });

  const loginRes = await axios({
    url: '/users/auth',
    method: 'POST',
    data: {
      username: 'sa',
      password: 'Qwerty123#',
    },
  });

  localStorage.setItem(hospitalTokenKey(), loginRes.data.token);

  if (!redirect) {
    return;
  }

  if (showSuccessModal) {
    await MySwal.fire({
      icon: 'success',
      title: 'Validasi Berhasil, Mohon Tunggu',
      text: 'Anda akan diarahkan ke halaman Profil.',
    });
    setTimeout(() => setHrefWithSlugHook('/profile'), redirectDelayMs);
    return;
  }

  setHrefWithSlugHook('/profile');
};
